module.exports = __webpack_public_path__ + "static/connerfritz-bad4961d3ec8bdf0778aefbbdd5b65a8.jpg";